<template>
  <div class="material-information">
    <re-dialog :visible.sync="show" title="设置商品其他信息" width="600px">
      <el-form label-width="100px" style="width: 100%;" class="p20">
        <el-form-item label="特殊要求">
          <el-checkbox-group v-model="company_requirement_json" class="requirement-checkbox-group">
            <el-checkbox
              v-for="i in requireList"
              :label="i.content"
              :key="i.content"
              class="requirement-checkbox"
              >{{ i.content }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <template v-if="!is_Empty(matchingInformation)">
          <p class="pb10 bold fz16">匹配物料信息</p>
          <el-form-item label="物料编号"
            >{{ matchingInformation.company_goods_no }}
          </el-form-item>
          <el-form-item label="物料名称">
            {{ matchingInformation.company_goods_name }}
          </el-form-item>
          <el-form-item label="规格名称">
            {{ matchingInformation.company_goods_specification_name }}
          </el-form-item>
        </template>
      </el-form>
      <div class="fr ac jc" slot="footer">
        <el-button size="small" @click="show = false">取消</el-button>
        <el-button type="primary" size="small" @click="submit">确定</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
export default {
  name: "materialInformation",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    goods: {
      type: Object,
      default: () => {
        return {};
      },
    },
    company_id: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(n) {
      this.show = n;
      n && this.init();
    },
    show(n) {
      this.$emit("input", n);
    },
  },

  data() {
    return {
      show: this.$props.value,
      company_goods_no: "",
      company_goods_name: "",
      company_requirement_json: [],
      requireList: [],
      matchingInformation: {},
    };
  },
  methods: {
    async init() {
      let {
        company_goods_no,
        company_goods_name,
        company_requirement_json,
        drawings,
        goods_id,
        specification_id,
        specification_inputs,
      } = this.$props.goods;

      if (!this.is_Empty(this.$props.company_id)) {
        let res = await this.post(
          "companyRequirement/getCompanyRequirementList",
          { company_id: this.$props.company_id },
        );
        this.requireList = res.data;
      }
      this.company_goods_no = company_goods_no;
      this.company_goods_name = company_goods_name;
      if (
        this.is_Empty(company_goods_no) &&
        this.is_Empty(company_goods_name)
      ) {
        let res = await this.jsonPost(
          "companyInterfaces/v1.0/getCompanyGoodsNameByPlatformGoodsIds",
          {
            platform_goods_id: goods_id,
            company_id: this.$props.company_id,
            specificationInputVOS: JSON.parse(specification_inputs),
            platform_specification_id: specification_id,
          },
        );
        this.matchingInformation = res.data;
      }
      if (!this.is_Empty(this.$props.company_id)) {
        let res = await this.post(
          "companyRequirement/getCompanyRequirementList",
          { company_id: this.$props.company_id },
        );
        this.requireList = res.data;
      }
      if (typeof company_requirement_json === "string") {
        company_requirement_json = JSON.parse(company_requirement_json);
      }
      let list = [];
      company_requirement_json.forEach((el) => {
        list.push(el.content);
      });
      this.company_requirement_json = list;
    },
    submit() {
      let goods = JSON.parse(JSON.stringify(this.$props.goods));
      goods.company_goods_no = this.company_goods_no;
      goods.company_goods_name = this.company_goods_name;
      let list = [];
      if (this.company_requirement_json.length) {
        this.requireList.forEach((el) => {
          if (this.company_requirement_json.indexOf(el.content) !== -1) {
            list.push({
              content: el.content,
              images: el.images,
            });
          }
        });
      }
      goods.company_requirement_json = JSON.stringify(list);
      this.$emit("success", goods);
      this.show = false;
    },
  },
};
</script>

<style scoped>
.material-information {
}
.requirement-checkbox-group {
  width: 100%;
}
.requirement-checkbox-group >>> .el-checkbox {
  display: flex;
  align-items: flex-start;
  margin-right: 0;
  margin-bottom: 8px;
}
.requirement-checkbox-group >>> .el-checkbox__label {
  white-space: normal;
  word-break: break-all;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/page/me/salesOrder/component/otherInfo.vue